<!-- UniDate Component Builder -->

<template>
	<div class="bld-unidate">
		<div class="title wi8_font">Uni Date Builder</div>

		<div class="lab-box">Beg Date:</div>
		<div class="pop-value-box" @click="popInput('dateBeg')" v-html="convertLFs(rec.dateBeg)"></div>

		<div class="v-spacer"></div>

		<div class="lab-box">End Date:</div>
		<div class="pop-value-box" @click="popInput('dateEnd')" v-html="convertLFs(rec.dateEnd)"></div>

		<div class="v-spacer"></div>
		<div class="v-spacer"></div>

		Content<br/>
		<div class="content">
			<UniDate 
				v-if="showComp"
				:compData="compData"
			/>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils.js";
import CfgApp from "@/assets/cfg/CfgApp";
import * as Utils from "@/utils/utils";
import { eventBus } from "@/main";
export default {
	data() {
		return {
			rec: {
				dateBeg: "2020-02-14",
				dateEnd: "",
			},
			compData: {},
			showComp: true,
		};
	},
	watch: {
		"rec.dateBeg": {
			deep: true,
			handler: function(newVal, oldVal) {
				this.compData.defaultVal = newVal;
				m("compData", this.compData);
			}
		}
	},
	methods: {
		popInput(colName) {
			this.showComp = false;
			Utils.showPopInput(colName, this.rec[colName]);
		},
		handleUpdateVal(payload) {
			m("handle update", payload);
			this.showComp = true;
			let colName = payload.colName || "dateBeg";
			let val = payload.val;
			this.rec[colName] = val;
			m("rec is now", this.rec);
		},
		convertLFs(str1="") {
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		handlePopoff() {
			this.showComp = true;
		},
	},
	created() {
		this.compData = {
			colName: "dateBeg",
			defaultVal: this.rec.dateBeg,
		};

		m("bld unidate: created", this.compData);

		eventBus.$emit('popoffall'); // Close all modal windows
		eventBus.$on('update-value', this.handleUpdateVal);
		eventBus.$on('popoff', this.handlePopoff);
	},
	beforeDestroy() {
		m("bld unidate: bef destroy");
		eventBus.$off('update-value', this.handleUpdateVal);
		eventBus.$off('popoff', this.handlePopoff);
	},
}
</script>

<style scoped>
.bld-unidate {
	height: 100%;
	overflow: hidden;
	padding: 5px;
	background-color: #FCFCEE;
	border: solid 0px #C30;
}

.title {
	height: 30px;
	color: #C60;
	border: solid 0px #369;
}

.content {
	height: calc(100% - 150px);
	overflow: hidden;
	border: solid 1px #369;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #C30;
}

.lab-box {
	display: inline-block;
	width: 80px;
	height: 22px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	border: solid 0px #369;
}

.pop-value-box {
	display: inline-block;
	width: 250px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

</style>
